import { Text } from 'roo-ui/components';

export interface RefundMessageProps {
  propertyName: string;
  email: string;
}

const RefundMessage = ({ propertyName, email }: RefundMessageProps) => (
  <Text fontSize="18px">
    Your booking at {propertyName} has been cancelled. You will receive a confirmation via email to <b>{email}</b>
    <br />
    <br />
    We hope to see you again soon.
  </Text>
);

export default RefundMessage;
